import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { format } from "date-fns";

export default function ComplianceMI() {
  const [stats, setStats] = useState({ openBreaches: 0, materialAmendments: 0, openDecisions: 0, conflicts: 0 });

  useEffect(() => {
    (async () => {
      const [b, a, d, c] = await Promise.all([
        supabase.from("compliance_breaches").select("id", { count: "exact", head: true }).in("status", ["detected","contained"]),
        supabase.from("compliance_policy_amendments").select("id", { count: "exact", head: true }).eq("is_material", true),
        supabase.from("compliance_decisions").select("id", { count: "exact", head: true }).eq("status", "open"),
        supabase.from("compliance_conflicts").select("id", { count: "exact", head: true }).eq("status", "active"),
      ]);
      setStats({
        openBreaches: b.count ?? 0,
        materialAmendments: a.count ?? 0,
        openDecisions: d.count ?? 0,
        conflicts: c.count ?? 0,
      });
    })();
  }, []);

  const print = () => window.print();

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle>MI / Disclosure Pack (§17)</CardTitle>
          <p className="text-sm text-muted-foreground mt-1">Generated {format(new Date(), "dd/MM/yyyy")}</p>
        </div>
        <Button size="sm" onClick={print}>Print / Export</Button>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          <div className="border rounded p-4"><div className="text-3xl font-bold">{stats.openBreaches}</div><div className="text-xs text-muted-foreground">Open breaches (§16)</div></div>
          <div className="border rounded p-4"><div className="text-3xl font-bold">{stats.openDecisions}</div><div className="text-xs text-muted-foreground">Open IC decisions (§14)</div></div>
          <div className="border rounded p-4"><div className="text-3xl font-bold">{stats.conflicts}</div><div className="text-xs text-muted-foreground">Active conflicts (§15)</div></div>
          <div className="border rounded p-4"><div className="text-3xl font-bold">{stats.materialAmendments}</div><div className="text-xs text-muted-foreground">Material amendments (§18)</div></div>
        </div>
        <div className="prose prose-sm dark:prose-invert">
          <p>This MI pack rolls up §11 (risk), §12 (attribution) and §13 (cost) metrics across all CBAM portfolios. Detailed per-portfolio risk and attribution panels are available on each P/R Risk and Portfolio Management page.</p>
          <p className="text-muted-foreground"><Badge variant="outline">Phase 2</Badge> Auto-generated PDF rollup with embedded VaR/TE/DD/Liquidity and attribution tables coming next.</p>
        </div>
      </CardContent>
    </Card>
  );
}
